import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddToWatchlistComponent } from './app.component';

const routes: Routes = [{ path: '', component: AddToWatchlistComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
